// src/components/ImageDropzone.js
import React, { useCallback, useRef } from 'react';
import { Box, Typography, Button } from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile';

const ImageDropzone = ({ onFilesAdded }) => {
  const inputRef = useRef(null);

  // Wrap handleFileChange in useCallback and add its dependency (onFilesAdded)
  const handleFileChange = useCallback((files) => {
    if (files && files.length > 0) {
      // The onFilesAdded function is a dependency from props
      onFilesAdded(Array.from(files));
    }
  }, [onFilesAdded]);

  const onDragOver = useCallback((event) => {
    event.preventDefault();
  }, []);

  // Now, add handleFileChange to the dependency array for onDrop
  const onDrop = useCallback((event) => {
    event.preventDefault();
    handleFileChange(event.dataTransfer.files);
  }, [handleFileChange]);

  const onZoneClick = () => {
    inputRef.current.click();
  };

  return (
    <Box
      onDragOver={onDragOver}
      onDrop={onDrop}
      onClick={onZoneClick}
      sx={{
        border: '2px dashed',
        borderColor: 'text.secondary',
        borderRadius: 2,
        p: 4,
        textAlign: 'center',
        cursor: 'pointer',
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'action.hover',
        transition: 'background-color 0.2s ease',
        '&:hover': {
          backgroundColor: 'action.selected',
        },
      }}
    >
      <input
        type="file"
        multiple
        ref={inputRef}
        onChange={(e) => handleFileChange(e.target.files)}
        style={{ display: 'none' }}
        accept="image/jpeg, image/png, image/gif, image/webp"
      />
      <UploadFileIcon sx={{ fontSize: 60, color: 'text.secondary' }} />
      <Typography variant="h6" color="text.secondary" mt={2}>
        Drag & Drop Your Images Here
      </Typography>
      <Typography color="text.secondary" mt={1}>
        or
      </Typography>
      <Button variant="outlined" sx={{ mt: 1 }}>
        Click to browse
      </Button>
    </Box>
  );
};

export default ImageDropzone;